export enum LedModeType {

    AUTO,
    MANUAL,
    LINKED,
    UNKNOWN

}

